<template>
  <div class="frame">
    <div class="container flex justify-center items-center flex-column">
      <div class="w-100 mb10" style="text-align:left">
        <h1 class="flex items-center flex-row">{{ $t('gdpr.title') }}</h1>
        <p class="ma0 mb20">
          {{ $t('gdpr.form1Instructions') }}
          <span v-if="this.variation == 1">{{ $t('gdpr.form1AdditionalInstructions') }}</span>
        </p>
      </div>
      <form method="POST" class="w-100" id="request-form">
        <div class="flex flex-column w-100" role="alert">
          <i18n path="gdpr.invalidCredentialsMessage.text" tag="p" id="form-error" class="dark-red" v-if="this.errorMessage">
            <a target="_blank" :href="accountRecoveryLink">{{ $t('gdpr.invalidCredentialsMessage.link') }}</a>
          </i18n>
          <!--p id="form-error" class="dark-red" v-if="errorMessage" v-html="errorMessage">
            Sorry, the credentials you\'ve entered do not match with any account for this site. Please try again or you can <a :href="accountRecoveryLink">recover</a> your password and/or email address.
          </p-->
          <p id="form-success" class="dark-green" v-if="successMessage">
            {{ successMessage }}
          </p>
        </div>
        <div class="flex flex-column w-100 mb20">
          <label class="mr10 bold mb5" for="email">
            <b>{{ $t('gdpr.emailLabel') }}*</b>
          </label>
          <input type="text" name="email" class="input ba h-35 br5 pa0 mb5 pl5 pr5" id="email" aria-invalid="false" v-model="email" />
        </div>
        <div class="flex flex-column w-100 mb10" v-if="this.variation == 1">
          <label class="mr10 bold mb5" for="name">
            <b>{{ $t('gdpr.nameLabel') }}</b>
          </label>
          <input type="text" name="name" class="input ba h-35 br5 pa0 mb5 pl5 pr5" id="name" aria-invalid="false" v-model="name" />
        </div>
        <div class="flex flex-column w-100 mb10" v-if="!this.variation == 1">
          <label class="mr10 bold mb5" for="name">
            <b>{{ $t('gdpr.passwordLabel') }}*</b>
          </label>
          <input type="password" name="password" class="input ba h-35 br5 pa0 mb5 pl5 pr5" id="password" aria-invalid="false" v-model="password" />
        </div>
        <div class="flex flex-column w-100 mb5">
          <i18n path="gdpr.accountRecoveryHelp.emailPassword" tag="p" v-if="this.variation != 1">
            <b>{{ $t('gdpr.accountRecoveryHelp.note') }}</b>
            <a target="_blank" :href="accountRecoveryLink">{{ $t('gdpr.accountRecoveryHelp.linkText') }}</a>
          </i18n>
          <i18n path="gdpr.accountRecoveryHelp.emailName" tag="p" v-if="this.variation == 1">
            <b>{{ $t('gdpr.accountRecoveryHelp.note') }}</b>
            <a :href="accountRecoveryLink">{{ $t('gdpr.accountRecoveryHelp.linkText') }}</a>
          </i18n>
        </div>
        <div class="flex flex-column w-100 mb20">
          <div id="captcha" style="width: 304px; height: 78px;">
            <Recaptcha ref="captcha" @captchaUpdate="updateCaptchaResponse"></Recaptcha>
          </div>
        </div>
        <div class=" mt20 w-100 mb5">
          <button type="submit" class="button h-35 br5 bg-blue white pointer bw0 fs16 w-50" id="submit-button" v-on:click="submitRequest" :disabled="!canSubmit">
            {{ $t('gdpr.submitButtonText') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Recaptcha from '@/components/Recaptcha';
import { csbpApi, environment } from '@/config/index.js';
export default {
  name: 'GDPR',
  data() {
    return {
      helpcenterType: '',
      siteId: '',
      siteName: '',
      domainName: '',
      language: '',
      email: '',
      name: '',
      password: '',
      variation: '', // variation between email & name and email & password.
      ticketId: '',
      requesterId: '',
      errorMessage: '',
      successMessage: '',
      isActive: true,
      targetOrigin: '',
      apiUrl: '',
      captchaResponse: '',
    };
  },
  computed: {
    accountRecoveryLink() {
      // members.domain/account/recovery
      // booksonly
      // bsweepshc
      // media
      // qsweepshc
      // sweepshc

      // domain/account/recoveryinfo
      // vpn
      // vsweepshc

      // neither?
      // cbdoil
      // csweepshc
      // ketohc
      // lsweepshc
      // quizzeshc

      switch (this.helpcenterType) {
        case 'media':
        case 'booksonly':
        case 'bsweepshc':
        case 'qsweepshc':
        case 'sweepshc':
          return `https://members.${this.domainName}/account/recovery`;
        case 'vpn':
        case 'vsweepshc':
          return `https://${this.domainName}/account/recoveryinfo`;
        default:
          return `https://support.${this.domainName}/${this.language}`;
      }
    },
    canSubmit() {
      return this.isActive && this.email.length && this.captchaResponse && (this.variation == 1 || this.password.length);
    },
  },
  methods: {
    getVariables() {
      this.siteId = this.$route.query.siteId ? this.$route.query.siteId : null;
      this.siteName = this.$route.query.siteName ? this.$route.query.siteName : null;
      this.domainName = this.$route.query.domainName ? this.$route.query.domainName : null;
      this.ticketId = this.$route.query.ticketId ? this.$route.query.ticketId : null;
      this.language = this.$route.query.language ? this.$route.query.language : null;
      this.requesterId = this.$route.query.code ? this.$route.query.code : null;
      this.variation = this.$route.query.v ? this.$route.query.v : null;
      this.helpcenterType = this.$route.query.helpcenterType ? this.$route.query.helpcenterType : null;
      this.targetOrigin = this.domainName && environment !== 'development' ? `https://support.${this.domainName}` : 'http://localhost:8080';
      this.apiUrl = `${csbpApi}/gdpr/request`;
    },
    syncIframeHeight() {
      if (document.body.scrollHeight !== window.innerHeight) {
        window.parent.postMessage(
          {
            type: 'resize',
            height: document.body.scrollHeight,
          },
          this.targetOrigin
        );
      }
    },
    updateCaptchaResponse(response) {
      this.captchaResponse = response;
    },
    async submitRequest(e) {
      e.preventDefault();
      this.isActive = false;
      this.errorMessage = '';
      this.successMessage = '';
      const request = {
        site_id: this.siteId,
        site_name: this.siteName,
        domain: this.domainName,
        email: this.email,
        lang: this.language,
        name: this.name ? this.name : undefined,
        password: this.password ? this.password : undefined,
        response: this.captchaResponse ? this.captchaResponse : undefined,
      };
      try {
        const response = await fetch(this.apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(request),
        });
        const data = await response.json();
        if (data.success !== true) {
          this.unsuccessfulHandler();
        }
        if (data.success === true && data.message === 'Email Successfully Sent') {
          this.successMessage = this.$t('gdpr.emailSentSuccessMessage');
        }
        if (data.success === true && data.gdprFormUrl) {
          let redirectUrl = data.gdprFormUrl;
          if (environment === 'development') {
            redirectUrl = data.gdprFormUrl.replace(`https://support.${this.domainName}`, this.targetOrigin);
          }
          window.parent.postMessage(
            {
              type: 'redirect',
              url: redirectUrl,
            },
            this.targetOrigin
          );
        }
      } catch (err) {
        // Just show the user the regular no credentials found message if an unexpected error occurs.
        this.unsuccessfulHandler();
      }
    },
    unsuccessfulHandler() {
      this.errorMessage = 'true';
      this.$refs.captcha.resetCaptcha();
      this.isActive = true;
    },
  },
  created() {
    this.getVariables();
    window.addEventListener('resize', () => {
      this.syncIframeHeight();
    });
    this.$i18n.locale = this.language;
  },
  mounted() {
    this.syncIframeHeight();

    // Load Recaptcha library
    let recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?hl=${this.language}`);
    document.head.appendChild(recaptchaScript);
  },
  updated() {
    this.syncIframeHeight();
  },
  components: { Recaptcha },
};
</script>

<style scoped>
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.frame {
  background-color: #f7f4f4;
}
.error-link {
  color: #e7040f;
  text-decoration: underline;
}

body {
  margin: 0;
  font-family: Roboto, Helvetica, Arial, sans-serif;
}

.form-group {
  margin-bottom: 1rem;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

#gdpr label {
  text-transform: capitalize;
  display: block;
  margin: 1em 0 1em 0;
}

.bg-gray {
  background-color: #f7f4f4;
}

.bg-blue {
  background-color: #0072ef;
}

.logo {
  width: 43px;
  height: 50px;
}

.pa10 {
  padding: 5px;
}

.flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.flex-row {
  flex-direction: row;
}

.justify-center {
  justify-content: center;
}

.items-center {
  align-items: center;
}

.w-25 {
  width: 25%;
}

.w-30 {
  width: 30%;
}

.w-50 {
  width: 50%;
}

.w-75 {
  width: 75%;
}

.w-80 {
  width: 80%;
}

.w-100 {
  width: 100%;
}

.h-35 {
  height: 35px;
}

.ma0 {
  margin: 0;
}

.mr10 {
  margin-right: 10px;
}

.mt20 {
  margin-top: 20px;
}

.mb5 {
  margin-bottom: 5px;
}

.mb10 {
  margin-bottom: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb30 {
  margin-bottom: 30px;
}

.bold {
  font-weight: 400;
}

.container {
  margin-right: auto;
  margin-left: auto;
  padding: 10px;
}

.input {
  outline-color: rgb(64, 169, 243);
  border-color: rgb(204, 204, 204);
}

.ba {
  border-style: solid;
  border-width: 1px;
}

.br5 {
  border-radius: 5px;
}

.white {
  color: rgb(255, 255, 255);
}

.pointer {
  cursor: pointer;
}

.bw0 {
  border-width: 0;
}

.button:hover {
  background-color: #004189;
}

.pa0 {
  padding: 0;
}

.pl5 {
  padding-left: 5px;
}

.pr5 {
  padding-right: 5px;
}

.fs12 {
  font-size: 12px;
}

.fs14 {
  font-size: 14px;
}

.fs16 {
  font-size: 16px;
}

p[aria-hidden='true'] {
  opacity: 0;
}

p[aria-hidden='false'] {
  opacity: 1;
}

.h15 {
  height: 10px;
}

input[aria-invalid='true'] {
  border-color: red;
}

button[disabled],
button[disabled]:hover {
  background-color: rgb(221, 221, 221);
  cursor: not-allowed;
}

.dark-red {
  color: #e7040f;
}

.dark-green {
  color: #007728;
}

@media screen and (min-width: 768px) {
  .container {
    width: 50%;
  }

  .w-75-ns {
    width: 50%;
  }
}

@media screen and (min-width: 1440px) {
  .container {
    width: 50%;
  }

  .w-75-ns {
    width: 50%;
  }
}

hr {
  height: 2px;
  background-color: lightgray;
}

/* MODAL */
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 40px 30px;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/* MODAL */
/* LOADING MODAL */
.lds-ring {
  display: inline-block;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  width: 64px;
  height: 64px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* LOADING MODAL */
.modal-mask.nd,
.lds-ring.nd,
.nd {
  display: none;
}
</style>
